/*
 * Very very inspired from vue-axios-plugin
 */

import axios from 'axios'
import util from 'util'
import i18n from '@/plugins/i18n.js';
import { rootCertificates } from 'tls';

const errors_for_redirect = [893,894,895,896,897,898,899];

let VueApiPlugin = {}

   /*
    * 'validateStatus' is used by Axios to
    * to validate a result, or to declare it 'failed'
    * As several queries like 'session/authenticate' return '4xx'
    * we need to declare this range in validateStatus :
    */
VueApiPlugin.install= (Vue, options) => {

   const defaultOptions = {
      validateStatus: function (status) {
         return status >= 200 && status < 509;
       },
   }

   const initOptions = {
      ...defaultOptions,
      ...options
   }

   if ( initOptions.config ) {
      axios.defaults.baseURL = initOptions.config.webservices.connect.url;
      axios.defaults.headers.common[initOptions.config.webservices.connect.apitokenname] = initOptions.config.webservices.connect.apikey;
      axios.defaults.headers.common['Content-Type'] = initOptions.config.webservices.connect.content_type;
   }

   const service = axios.create(initOptions)

   Vue.prototype.$axios = service

   Vue.prototype.$api = {
      
      async executeStatic (resource) {
         // inject the accessToken for each request
         // and the Session Token
         var currentSession = sessionStorage.getItem("session")
         var sessionToken   = initOptions.config.webservices.connect.sessiontokenname;
         let method = 'get';
         let data = null;

         var _service = { method, url: resource, headers: {}, timeout: 120000, data };
         if ( currentSession!=null ) {
            _service.headers = { [sessionToken]: currentSession };
         }

         return service(
            _service
         ).then(res => {
            return res.data
         }).catch(error => {
            return error
         })
      },

      async execute (method, resource, data=null) {
         // inject the accessToken for each request
         // and the Session Token
         var currentSession = sessionStorage.getItem("session")
         var sessionToken   = initOptions.config.webservices.connect.sessiontokenname;
         //console.log('in execute, session='+currentSession)
         //console.log('in execute, sessionToken='+sessionToken)

         if ( method=='get' && data!=null ) {
            var queryString = Object.keys(data).map(function(key) {
               return key + '=' + data[key]
            }).join('&');
            if ( queryString!='') {
               resource = resource+'?'+queryString;   
            }
         }

         var _service = { method, url: resource, headers: {}, timeout: 120000, data };
         if ( currentSession!=null ) {
            _service.headers = { [sessionToken]: currentSession };
         }

         console.log( 'execute: _service='+JSON.stringify(_service))

         return service(
            _service
         ).then(res => {
            return res.data
         }).catch(error => {
            return error
         })
      },

      hexEncode(str) {
         var hex, i;
         var result = "";
         for (i=0;i<str.length;i++) {
            hex = str.charCodeAt(i).toString(16);
            result += ("000"+hex).slice(-4);
         }
         return result;
      },

      _build_actionname(actionname=null) {
         let method = '';
         if ( actionname!=null ) {
            method = '/'+actionname;
         }
         return method;
      },

      _basename(str) {
         return str.substr(str.lastIndexOf('/') + 1);
      },

      async getStatic( router, url ) {
         let result = await this.executeStatic(url);
         let errorinfos = this.analyze_data(router,result);
         return { errorinfos: errorinfos, api_response: result }
      },
      async getRow( router, keyword, id, option=null) {
         let method = this._build_actionname(option);
         let result = await this.execute('get', `/${keyword}/${id}${method}`);
         let errorinfos = this.analyze_data(router,result);
         return { errorinfos: errorinfos, api_response: result }
      },
      async createRow( router, keyword, data, actionname=null ) {
         let method = this._build_actionname(actionname);
         //console.log('createRow, keyword='+keyword)
         let result = await this.execute('post', `/${keyword}${method}`, data);
         let errorinfos = this.analyze_data(router,result);
         return { errorinfos: errorinfos, api_response: result };
      },
      async getRows( router, keyword, data=null ) {
         let result = await this.execute('get', `/${keyword}`, data);
         let errorinfos = this.analyze_data(router,result);
         return { errorinfos: errorinfos, api_response: result }
      },
      async updateRow( router, keyword, id, data=null, actionname=null ) {
         let method = this._build_actionname(actionname);
         let result = await this.execute('put', `/${keyword}/${id}${method}`, data);
         let errorinfos = this.analyze_data(router,result);
         return { errorinfos: errorinfos, api_response: result };
      },
      async deleteRow( router, keyword, id, actionname=null)  {
         let method = this._build_actionname(actionname);
         let result = await this.execute('delete', `/${keyword}/${id}${method}`);
         let errorinfos = this.analyze_data(router,result);
         return { errorinfos: errorinfos, api_response: result };
      },

      async login(router, username, password, locale=NULL) {
         let parameters = {'ses_username': username, 'ses_password': password };
         let { errorinfos, api_response } = await this.createRow(router,'session/authenticate',parameters);
         return { errorinfos: errorinfos, api_response: api_response }
      },

      async _get_session(router,option=null) {
         var currentSession = sessionStorage.getItem("session");
         var { errorinfos, api_response } = await this.getRow(router,'session',currentSession,option);
         return { errorinfos: errorinfos, api_response: api_response }
      },

      async _delete_session(router,option=null) {
         var currentSession = sessionStorage.getItem("session");
         var { errorinfos, api_response } = await this.deleteRow(router,'session',currentSession,option);
         if ( api_response.error==0 ) {
            sessionStorage.removeItem("session");
         }
         return { errorinfos: errorinfos, api_response: api_response }
      },

      _get_pk_by_value(_array,value,propertyname) {
         for ( var i= 0; i < _array.length; i++ ) {
            if ( _array[i] && _array[i]._pk && _array[i][propertyname] && _array[i][propertyname]==value ) {
               return _array[i]._pk
            }
         }
         return null;
      },

      _remove_by_pk(_array,_pk) {
         for ( var i= 0; i < _array.length; i++ ) {
            if ( _array[i] && _array[i]._pk && _array[i]._pk==_pk ) {
               _array.splice(i,1);
               break;
            }
         }
      },

      _get_by_pk(_array,_pk) {
         for ( var i= 0; i < _array.length; i++ ) {
            if ( _array[i] && _array[i]._pk && _array[i]._pk==_pk ) {
               return _array[i];
            }
         }
         return null;
      },

      /*
       * 2020-05-28, SDO : This function does not work... To be finished...
       * Was required by ddoClistListTreeViewLDAP...
       */
      _get_parent_by_id(_array,id,self=null) {
         var node;
         if ( self==null ) { self = this; }
         _array.some(function (n) {
            if ( n.id===id ) {
               return node = n;
            }
            if ( n.children ) {
               return node = self._get_parent_by_id(n.children,id,self);
            }
         });
         return node || null;
      },

      _get_first_cn_from_ldap(ldap) {
         var _split1 = ldap.split(',');
         if ( _split1.length>0 ) {
            var _split2 = _split1[0].split('=');
            if ( _split2.length>1) {
               return _split2[1];
            }
         }
         return null;
      },
      
      _check_password(password,method=1,length=10) {
         var result =false;
         if ( password==null ) {
            return result;
         }
         switch (method) {
            case 1 :
               result = (password.length>=length);
               break;
            case 2 :
               result = (password.length>=length);
               if ( result ) {
                  let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                  for (var i=1;i<password.length;i++) {
                     result = ( result && chars.indexOf(password[i])>=0 );
                  }
               }
               break;
            }
         return result;
      },

      _generate_password(method=1,length=10) {
         var password = '';
         switch (method) {
            case 1 :
               password = Math.random().toString(36).slice(2);
               password = password.substring(0,length);
               break;
            case 2 :
               let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
               for (var i=1;i<length;i++) {
                  let c = Math.floor(Math.random()*chars.length + 1);
                  password += chars.charAt(c);
               }
               break;
            }
         return password;
      },

      _check_passwordcomplexity(password) {
         if ( password==null ) { return false }
         let criteria0 = ( password.length>=8 );
         let criterias = 0;
         if ( password.match(/[a-z]+/) ) { criterias++; };
         if ( password.match(/[A-Z]+/) ) { criterias++; };
         if ( password.match(/[0-9]+/) ) { criterias++; };
         if ( password.match(/[&!§]+/) ) { criterias++; };
         return ( criteria0 && criterias>=3 );
      },

      _datetime(data) {
         if ( data===null || typeof data==='undefined' ) {
            return null
         } else {
            // FIRST  : includes the 'T' marker, between day and time parts
             let _date = data.replace(/([0-9-]+) ([0-9-.:]+)/g,'$1T$2')
             // SECOND : drops decimals in seconds, if more than 3 decimals (Postgresql returns 6), and keeps timezone if included (not tested)
            _date = _date.replace(/T([0-9].*:[0-9].*:[0-9].*\.)([0-9]{3})([0-9]{0,3})/g,'T$1$2')
            // THIRD : If timezone is specified (in the form +NN, at the end), we must add :00 => +NN:00
            // Same thing for -NN
            _date = _date.replace(/\+([0-9]{2,2})$/g,'+$1:00')
            if ( _date.length>10 ) {
               _date = _date.replace(/\-([0-9]{2,2})$/g,'-$1:00');
            }
            return _date
         }
      },

      _d(data,format='short',locale='fr') {
         let date = this._datetime(data);
         if ( date===null ) {
            return null
         } else {
            var _formatted = null;
            try {
               _formatted = i18n.d(new Date(date),format,locale);
            } catch(error) {
               _formatted = null;
            }
            return _formatted;
         }
      },

      _build_array_of_datetime_for_picker(date1,date2) {
         var ret = [];
         ret.push( date1==null ? new Date() : new Date(date1.substring(0,19)) );
         ret.push( date2==null ? new Date() : new Date(date2.substring(0,19)) );
         return ret;
      },

      _format(string,value) {
         return util.format(string,value);
      },

      _format_bytes(value,format,with_unity=false,decimal=2) {
         var result = value;
         var unity = '';
         switch ( format ) {
            case 'mega':
               result = parseFloat(value/(1024*1024)).toFixed(decimal);
               if ( with_unity ) { unity = " "+i18n.t("utils.MB"); }
               break;
            case 'giga':
               result = parseFloat(value/(1024*1024*1024)).toFixed(decimal);
               if ( with_unity ) { unity = " "+i18n.t("utils.GB"); }
               break;
         }
         result += unity;
         return result;
      },

      analyze_data(router,data) {
         //console.log('analyze_data, data='+JSON.stringify(data))
         if ( data && data.error ) {
            if ( errors_for_redirect.includes(data.error) ) {
               sessionStorage.setItem("errorinfos",JSON.stringify(data.errorinfos))
               router.push('/pages/login')
            }
         }
         if ( data && data.errorinfos ) {
            return data.errorinfos;
         }
         return null
      },
      
      async refresh_rows(router,key,caller,callerlevel,previouserrorinfos=false) {
         caller.loading = true;
         let { errorinfos, api_response } = await this.getRows(router,key);
         caller.loading = false;
         let errors = [];
         if ( previouserrorinfos!==false ) {
            errors = [previouserrorinfos];
         }
         errors = errors.concat([errorinfos]);
         callerlevel.errors = errors;
         if ( api_response.error==0 ) {
            callerlevel.rows = api_response.rows;
         } else {
            callerlevel.rows = []
         }
      },

      async load_for_create(caller) {
         caller.errors = [];
         caller.configure_form(false,true,false,false);
         //caller.row = initial_row;
         caller.showDialog(true);
      },

      async load_for_update(router,key,_pk,caller) {
         // For an unknown reason, this.getRow does not work (undefined function)
         // We need to call 'caller.$api.getRow'
         caller.errors = [];
         caller.loading = true;
         let { errorinfos, api_response } = await caller.$api.getRow(router,key,_pk);
         caller.loading = false;
         if ( api_response.error!=0 ) {
            caller.errors = [ errorinfos ];
         }
         if ( api_response.row ) {
            caller.row = api_response.row;
            caller.callbacks.configure_form(false,false,true,false);
            caller.callbacks.showDialog(true);
         }
      },

      async load_for_delete(router,key,_pk,caller) {
         // For an unknown reason, this.getRow does not work (undefined function)
         // We need to call 'caller.$api.getRow'
         caller.errors = [];
         caller.loading = true;
         let { errorinfos, api_response } = await caller.$api.getRow(router,key,_pk);
         caller.loading = false;
         if ( api_response.error!=0 ) {
            caller.errors = [ errorinfos ];
         }
         if ( api_response.row ) {
            caller.row = api_response.row;
            caller.configure_form(false,false,false,true);
            caller.showDialog(true);
         }
      },

      async create_row(router,keyword,row,caller,level=0) {
         let { errorinfos, api_response } = await caller.$api.createRow(router,keyword,row);
         //caller.errors = [ errorinfos ];
         //this.refresh_rows(router,keyword,caller,errorinfos);
         //caller.show_dialog(level,false);
      },

      async update_row(router,keyword,_pk,row,caller) {
         let { errorinfos, api_response } = await this.updateRow(router,keyword,_pk,row);
         caller.errors = [ errorinfos ];
         if ( api_response.error==0 ) {
            this.refresh_rows(router,keyword,caller,errorinfos);
            caller.showDialog(false);
         }
      },

      async delete_row(router,keyword,_pk,caller) {
         let { errorinfos, api_response } = await caller.$api.deleteRow(router,keyword,_pk);
         caller.errors = [ errorinfos ];
         if ( api_response.error==0 ) {
            this.refresh_rows(router,keyword,caller,errorinfos);
            caller.showDialog(false);
         }
      },

      _replaceAll(str, find, replace) {
         return str.replace(new RegExp(find, 'gi'), replace);
      },

      _hilite(str, find ) {
         return str.replace(new RegExp(find, 'gi'), function (x) { return '<mark>'+x+'</mark>'; });
      },

      get_pdf_link(relative_link,config) {
         var api_token_name = config.webservices.connect.apitokenname;
         var apikey = config.webservices.connect.apikey;
         var session_token_name = config.webservices.connect.sessiontokenname;
         var currentSession = sessionStorage.getItem("session")
         console.log('api.get_pdf_link, return='+config.webservices.documents.url + '?' + api_token_name + '=' + apikey + '&' + session_token_name + '=' + currentSession + '&pdf=' + relative_link)
         return config.webservices.documents.url + '?' + api_token_name + '=' + apikey + '&' + session_token_name + '=' + currentSession + '&pdf=' + relative_link;
      },

   }

   // Auto-install
   let GlobalVue = null
   if (typeof window !== 'undefined') {
      GlobalVue = window.Vue
   } else if (typeof global !== 'undefined') {
      GlobalVue = global.Vue
   }
   if (GlobalVue) {
      GlobalVue.use(VueApiPlugin)
   }

}

export default VueApiPlugin